<template>
   <div class="form__item">
      <label :for="id" class="input__label">
         <slot name="label"></slot>
         <span v-if="required == true" class="required">*</span>
      </label>

      <label v-if="image == true" class="input__file--container">
         <input v-on:change="onchange" :id="id" class="input__file js-input__file" type="file" accept="image/*" aria-label="file" :disabled="disabled" :required="required" ref='input'>
         <tisc-Button @click="$refs.input.click()" :class="buttonClasses" color="blue">Choose File</tisc-Button>
         <span :class="filepathClasses" :data-input="id">{{fileName}}</span>
      </label>

      <label v-else class="input__file--container">
         <input v-on:change="onchange" :id="id" class="input__file js-input__file" type="file" aria-label="file" :disabled="disabled" :required="required" ref='input'>
         <tisc-Button @click="$refs.input.click()" :class="buttonClasses" color="blue">Choose File</tisc-Button>
         <span :class="filepathClasses" :data-input="id">{{fileName}}</span>
      </label>
   </div>
</template>

<script>
import tiscButton from '../Elements/tiscButton.vue'
export default {
	components: { tiscButton },
   data() {
      return {
         fileName: 'No file chosen'
      }
   },
   props: {
      id: { type: String, default: null },
      required: { type: Boolean, default: false },
      autofocus: { type: Boolean, default: false },
      disabled: {type: Boolean, default: false},
      image: {type: Boolean, default: false},
      value: {
         validator: prop => ['string', 'number'].includes(typeof prop) || prop === null,
         default: null
      }
   },
   computed: {
      inputValue: {
         get () {
            return this.value
         },
         set (value) {
            this.emitValue(value)
         }
      },
      buttonClasses () {
         const { image, disabled } = this
            
         return [
            image ? 'input__file--button-img' : 'input__file--button',
            ...(disabled ? [`disabled`] : [null]),
         ]
      },
      filepathClasses () {
         const { fileName } = this
         return [
            'input__file--text',
            fileName != 'No file chosen' ? 'active' : null
         ]
      }
   },
   methods: {
      emitValue (value) {
         this.$emit('input', value)
      }, 
      onchange(e) {
         this.fileName = e.target.value
      }
   }
}
</script>

<style lang="scss" scoped>
@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Forms/file.scss';
</style>